export const generateContextNotFoundError = (hookName: string) => {
  const providerName = hookName.replace(/^use/, '');
  return new Error(`${hookName} must be used within a ${providerName}Provider`);
};
